const tokens = {};
const rowVariantGroups = {
    spacing: {
        xs: {
            itemMarginRight: 4,
        },
        sm: {
            itemMarginRight: 8,
        },
        md: {
            itemMarginRight: 16,
        },
        lg: {
            itemMarginRight: 32,
        },
        xl: {
            itemMarginRight: 64,
        },
        between: {
            justifyContent: 'space-between',
        },
        around: {
            justifyContent: 'space-around',
        },
    },
    fit: {
        block: {
            flex: 0,
        },
        fill: {
            flex: 1,
        },
    },
};
const colVariantGroups = {
    spacing: {
        xs: {
            itemMarginRight: 0,
            itemMarginBottom: 4,
        },
        sm: {
            itemMarginRight: 0,
            itemMarginBottom: 8,
        },
        md: {
            itemMarginRight: 0,
            itemMarginBottom: 16,
        },
        lg: {
            itemMarginRight: 0,
            itemMarginBottom: 32,
        },
        xl: {
            itemMarginRight: 0,
            itemMarginBottom: 64,
        },
        between: {
            justifyContent: 'space-between',
        },
        around: {
            justifyContent: 'space-around',
        },
    },
    fit: {
        block: {
            flex: 0,
        },
        fill: {
            flex: 1,
        },
    },
};
const theme = {
    meta: {
        scope: 'all',
        parameters: {
            minWidth: {
                type: 'number',
            },
            minHeight: {
                type: 'number',
            },
            paddingHorizontal: {
                type: 'number',
            },
            paddingVertical: {
                type: 'number',
            },
            borderRadius: {
                type: 'number',
            },
            borderColor: {
                type: 'string',
            },
            borderWidth: {
                type: 'number',
            },
            backgroundColor: {
                type: 'string',
            },
            flexDirection: {
                type: 'string',
            },
            flexWrap: {
                type: 'string',
            },
            justifyContent: {
                type: 'string',
            },
            alignItems: {
                type: 'string',
            },
            itemMarginRight: {
                type: 'number',
            },
            itemMarginBottom: {
                type: 'number',
            },
            flex: {
                type: 'number',
            },
        },
        appearances: {
            row: {
                default: true,
            },
            col: {
                default: false,
            },
            rowReverse: {
                default: false,
            },
            colReverse: {
                default: false,
            },
        },
        variantGroups: {
            spacing: {
                xs: {
                    default: false,
                },
                sm: {
                    default: false,
                },
                md: {
                    default: false,
                },
                lg: {
                    default: false,
                },
                xl: {
                    default: false,
                },
                between: {
                    default: false,
                },
                around: {
                    default: false,
                },
            },
            fit: {
                block: {
                    default: false,
                },
                fill: {
                    default: false,
                },
            },
        },
        states: {},
    },
    appearances: {
        row: {
            mapping: {
                flexDirection: 'row',
            },
            variantGroups: rowVariantGroups,
        },
        col: {
            mapping: {
                flexDirection: 'column',
            },
            variantGroups: colVariantGroups,
        },
        rowReverse: {
            mapping: {
                flexDirection: 'row-reverse',
            },
            variantGroups: rowVariantGroups,
        },
        colReverse: {
            mapping: {
                flexDirection: 'column-reverse',
            },
            variantGroups: colVariantGroups,
        },
    },
};
export default {
    tokens,
    theme,
};
//# sourceMappingURL=DNABox.theme.alucio.js.map